require('./about-us-full-bio.scss');